module.exports = __webpack_public_path__ + "static/media/quantrolkz.9fd9427e.pdf";